import gql from 'graphql-tag';
import Address from './Address';
import AshLocation from './AshLocation';
import AuthorisedContact from './AuthorisedContact';
import Client from './Client';
import CremationDateHistory from './CremationDateHistory';
import CremationManagerAddressBook from './AddressBook';
import CremationOrderStaffMember from './CremationOrderStaffMember';
import Deceased from './Deceased';
import DispatchDate from './DispatchDate';
import Enquiry from './Enquiry';
import Member from './Member';
import SpecialInstruction from './SpecialInstruction';
import ReflectionRoom from './ReflectionRoom';
import RequiredDocument from './RequiredDocument';
import Invoice from './Invoice';
import Pickup from './Pickup';

export default gql`
    fragment CremationOrder on CremationOrder {
        ID
        LegacyKey
        CremationDate
        CremationTime
        Recipient
        DeliveredBy
        IsDeliveryOnly
        FuneralService
        EstimatedDeliveryDate
        EstimatedDeliveryTime
        EstimatedDeceasedWeight
        EstimatedDeliveredBy
        DeliveryDate
        DeliveryTime
        DeceasedWeight
        EstimatedInsertionDate
        EstimatedInsertionTime
        InsertionDate
        InsertionTime
        CremationEndDate
        CremationNumber
        CremationEndTime
        CremationActionNotes
        UseCoronerCertificates
        HasMissingCertificates
        CremationPending
        CremationComplete
        CremationCancelled
        CancelledDate
        CancelledReason
        ReadyForCremation
        AdditionalNotes
        PickupMethod
        Deceased {
            ...Deceased
        }
        DestinationAddress {
            ...Address
        }
        SpecialInstructions {
            ...SpecialInstruction
        }
        DispatchDates {
            ...DispatchDate
        }
        CremationDateHistories {
            ...CremationDateHistory
        }
        Enquiry {
            ...Enquiry
        }
        Funeral {
            ID
            LegacyKey
            LegacyDocuments {
                ... on File {
                    ID
                    Name
                    Size
                    AbsoluteLink
                }
                ... on Image {
                    ID
                    Name
                    Size
                    AbsoluteLink
                }
            }
            PlaceOfService {
                ID
                Type
            }
        }
        AshLocations {
            ...AshLocation
        }
        Business {
            ...CremationManagerAddressBook
        }
        CremationOperator {
            ...Member
        }
        DeliveryReceivedBy {
            ...Member
        }
        AuthorisedContacts {
            ...AuthorisedContact
        }
        Invoices {
            ...Invoice
        }
        Client {
            ...Client
        }
        StaffMembers {
            ...CremationOrderStaffMember
        }
        SignificantDocuments {
            ... on File {
                ID
                Name
                Size
                AbsoluteLink
            }
            ... on Image {
                ID
                Name
                Size
                AbsoluteLink
            }
        }
        RequiredDocuments {
            ...RequiredDocument
        }
        WitnessOfInsertionRequired
        ReflectionRoomRequired
        ReflectionRoom {
            ...ReflectionRoom
        }
        Pickup {
            ...Pickup
        }
        SameDayCremation
        NextDayCremation
        HadPacemaker
        HadPacemakerRemoved
        RequestsCertificateOfContents
        EnquirerWasBusiness
    }
    ${Address}
    ${AshLocation}
    ${AuthorisedContact}
    ${Client}
    ${CremationDateHistory}
    ${CremationManagerAddressBook}
    ${CremationOrderStaffMember}
    ${Deceased}
    ${DispatchDate}
    ${Enquiry}
    ${Member}
    ${SpecialInstruction}
    ${ReflectionRoom}
    ${RequiredDocument}
    ${Invoice}
    ${Pickup}
`;
